import React, { useEffect } from 'react';
import ScreenHeading from '../../../utils/ScreenHeading/ScreenHeading';
import ScrollService from '../../../utils/ScrollService';
import Animations from '../../../utils/Animations';
import "./AboutMe.css";

export default function AboutMe ( props )
{

  // Subscribe to observables to enable smooth scrolling and fading event 
  let fadeInScreenHandler = ( screen ) =>
  {
    if ( screen.fadeInScreen !== props.id ) return;
    Animations.animations.fadeInScreen( props.id );
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe( fadeInScreenHandler );

  useEffect( () =>
  {
    return () =>
    {
      fadeInSubscription.unsubscribe();
    };
  }, [ fadeInSubscription ] );


  const SCREEN_CONSTANTS = {
    description: "Full stack web and mobile developer with background knowledge in MERN stack with redux, along with a knack of applications with utmost efficiency. Strong professional with a BSC willing to be asset for an orgranisation.",
    highlights: {
      heading: "Here are a few highlights:",
      bullets: [
        "Full Stack Web and mobile develoepment",
        "Interactive Front end as per the design",
        "Android studio, Reactive",
        "NodeJS, Express, MongoDB (All backend technologies)",
        "Docker, Kubernetes, AWS",
        "Full Stack Web and mobile develoepment",
      ]
    }
  };

  const renderHighlightBullets = () =>
  {
    return SCREEN_CONSTANTS.highlights.bullets.map( ( bulletValue, i ) => (
      <div className="highlight-bullets" key={ i }>
        <div className="highlight-blob"></div>
        <span>{ bulletValue }</span>
      </div>
    ) );
  };

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={ props.id || "" }
    >
      <div className='about-me-parent'>

        <ScreenHeading title={ 'About Me' } subHeading={ 'Why Choose Me?' } />

        <div className='about-me-card row justify-content-center shadow-lg my-5'>

          {/* Left side image */ }
          <div className='col-lg-6 col-md-6 col-sm-12 d-flex align-items-center justify-content-center'>
            {/* <div className='about-me-profile-picture'></div> */ }
            <lottie-player
              className="lottie-player"
              src="https://assets1.lottiefiles.com/packages/lf20_v1yudlrx.json" background="transparent"
              speed="1"
              // style={ { width: "500px", height: "500px" } }
              loop
              autoplay>
            </lottie-player>
          </div>

          {/* Right side bullets */ }
          <div className='about-me-details col-lg-6 col-md-6 col-sm-12 py-5 d-flex flex-column'>
            <span className='about-me-description'>
              { SCREEN_CONSTANTS.description }
              <br />
              <br />
            </span>

            <div className='about-me-highlights'>
              <div className='highlight-heading'>
                <div >
                  <span>{ SCREEN_CONSTANTS.highlights.heading }</span>
                </div>
              </div>
              { renderHighlightBullets() }
              <br />
            </div>
            {/* <div className='about-me-options'>
              <button className='btn primary-btn'
                onClick={ () => ScrollService.scrollHandler.scrollToHireMe() }
              >Hire Me
              </button>
              <a href='resume_yong_ming_wei.pdf.pdf' download='resume_yong_ming_wei.pdf'>
                <button className='btn highlighted-btn'>Get Resume</button>
              </a>
            </div> */}
          </div>

        </div>


      </div>
    </div>
  );
}